// Classe de webSocket
// Esta classe foi criada com o intuito de padronizar as mensagens enviadas no WebSocket do projeto
// além de ter como visão fazer com que o sistema se comunique de forma rápida e prática
// junto ao websocket também estão sendo usados os Subjects para atualização dos componentes de forma rápida e precisa

export class WebSocketContent {
    code: _code;
    type_recipient: _type_recipient;
    uuid_chamado: string = null;
    sender: sender;
    content: any;
    msgIdentify: string;
    recipient: string | Array<any>;
    uuid_orcamento: string = null;
    constructor() {
        this.sender = new sender();
    }
}

export class sender {
    uuid: string;
    name: string;
    date_time: string = new Date().toISOString();
    session: string;// esse atributo serve para identificar a instancia do usuário caso ele esteja com mais de um navegador aberto
    // também pode ser usado para outros tipos de identificação, sempre que essa classe é instanciada um novo guid da sessão é gerado,
    // mas caso queira usar como identificador único para ser usado em banco como uuid ou uma guid aconselho a troca da função
    // que gera o código da sessão, como seu uso não é atemporal ele pode se repetir com muitos usos

    constructor() {
        this.session = this.generateRandomSession();
    }

    private generateRandomSession(): string {
        return 'xxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}

export type _type_recipient = 'directional' | 'suport_chamado' | 'suport_diretcional' | 'general' | 'server' | 'notification' | 'company' | 'erro_monitoring' | 'intern' | 'self' | 'orcamento';
// directional - direcionado para um usuário
// suport_chamado - direcionado para um chamado
// suport_diretcional - direcionado para um 
// general - mensagens geral do sistema
// server - mensagens direcionadas para o servidor
// notification - direcionado para component de notificação
// company - direcionado para uma empresa em específico
// erro_monitoring - direcionado para o monitoramento de erro das chamadas assincronas
// intern - direcionado para comunicação intera (mesma instancia, não envia no WebSocket)
// self- direcionada para comunicação interna (instancias diferentes, envia no WebSocket)
export type _code = -1 | 0 | 1 | 2 | 13 | 14 | 20 | 21 | 23 | 24 | 25 | 26 | 27 | 28 | 30 | 31 | 41 | 42 | 200 | 500;
// -1 - WebSocket desconectado
// 0 - WebSocket conectado
// 1 - alteração na chave de criptografia
// 2 - Falha de segurança WebSocket (trocar chave de criptografia)
// 3 - desconexão de usuário (usado para manter instancias do usuário aberto apenas em um navegador) // NOT IMPLEMENTED
// 13 - alerta gestor de novo chamado
// 14 - alerta gestor de nova interação no chamado
// 20 - interação de chamados
// 21 - obtenção de novo protocolo
// 23 - liberar protocolo (chamado)
// 24 - novo anexo (chamados)
// 25 - alteração na lista de notificação
// 26 - adição de descrição no chamado
// 27 - alteração no status do chamado
// 28 - alteração na categoria do chamado
// 30 - novo orçamento // NOT IMPLEMENTED
// 31 - atualização orçamento (usada para quando houve alguma alteração cadastral no orçamento) // NOT IMPLEMENTED
// 32 - atualização orçamento (usada para quando houve alguma alteração na atribuição do orçamento) // NOT IMPLEMENTED
// 41 - Nova mensagem ChatIdependente
// 42 - Nova mensagem ChatIdependente Orcamento
// 200 - código interno para indicar sucesso
// 500 - erro de servidor não tratado

// programação
// para alterações de orçamentos deixar reservado os códigos entre 30 e 40
// para módulo de chat idependente deixar reservado os códigos entre 40 e 50
// para mensagens de sistema deixar reservado os códigos entre 0 e 10
// para monitoramento interno do servidor deixar reserdo os códigos entre 100 e 199


export const _success: WebSocketContent = {
    code: 200,
    type_recipient: 'intern',
    sender: new sender(),
    uuid_chamado: null,
    content: 'success',
    msgIdentify: null,
    recipient: 'intern',
    uuid_orcamento: null
}

export const _desconnect: WebSocketContent = {
    code: -1,
    type_recipient: 'intern',
    sender: new sender(),
    uuid_chamado: null,
    content: 'WebSocket Desconnected',
    msgIdentify: null,
    recipient: 'intern',
    uuid_orcamento: null
}

export const _connect: WebSocketContent = {
    code: 0,
    type_recipient: 'intern',
    sender: new sender(),
    uuid_chamado: null,
    content: 'WebSocket Connected',
    msgIdentify: null,
    recipient: 'intern',
    uuid_orcamento: null
}